module.exports = __webpack_public_path__ + "static/media/Map1.dccd9286.glb";